import { keyMirror } from '@tunein/web-utils';

export const sharePlatformNames = keyMirror('FACEBOOK', 'TWITTER', 'TUMBLR');
